import { Form, Link, useSearchParams } from "react-router-dom";
import { tokenLoader } from "../../utils/auth";

function AdminNavBar() {
  const [searchParams] = useSearchParams();
  const localStorageValues = tokenLoader();

  // Get name from localStorage like the main app does
  const name = localStorageValues.name;

  // Determine current tab from search params
  const tab = searchParams.get("tab");
  const currentTab =
    tab === "logs"
      ? "logs"
      : tab === "registered-cpas"
      ? "registered-cpas"
      : tab === "affiliate-applications"
      ? "affiliate-applications"
      : tab === "unaccepted-filings"
      ? "unaccepted-filings"
      : "validate-license";

  const isChecked = (tabKey) => {
    return currentTab === tabKey;
  };

  return (
    <div className="navegation">
      <Link className="brand" to="/custom-admin/dashboard">
        <svg
          height="30"
          viewBox="0 0 300 75"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
          style={{ borderRadius: 0 }}
        >
          <path d="M0.278932 73.5265L0.278933 3.65637L26.7298 27.6118L16.2493 51.5673V73.5265H0.278932ZM51.1554 26.3536C50.8714 20.2194 48.4914 15.0374 44.0975 10.6434C39.4062 5.95211 33.617 3.65637 26.7298 3.65637H3.25826L28.3198 26.3535L51.1554 26.3536ZM51.1743 28.3536C51.0029 34.714 48.6142 40.0635 44.0975 44.5803C39.4062 49.2715 33.617 51.5673 26.7298 51.5673H18.4322L28.5882 28.3535L51.1743 28.3536ZM74.1415 73.5265V0.661957H59.1694V73.5265H74.1415ZM121.33 28.3105C117.837 24.2182 112.846 22.2219 106.458 22.2219C99.8703 22.2219 94.2807 24.817 89.5894 29.9076C84.8981 34.9981 82.6023 41.1866 82.6023 48.5729C82.6023 55.9591 84.8981 62.2475 89.5894 67.338C94.2807 72.4286 99.8703 74.9239 106.458 74.9239C112.846 74.9239 117.837 72.9276 121.33 68.8353V73.5265H136.303V23.6193H121.33V28.3105ZM100.868 57.4563C98.6725 55.2604 97.5745 52.266 97.5745 48.5729C97.5745 44.8797 98.6725 41.8853 100.868 39.6894C103.064 37.4935 105.959 36.3955 109.453 36.3955C112.946 36.3955 115.841 37.4935 118.037 39.6894C120.232 41.8853 121.33 44.8797 121.33 48.5729C121.33 52.266 120.232 55.2604 118.037 57.4563C115.841 59.6523 112.946 60.7502 109.453 60.7502C105.959 60.7502 103.064 59.6523 100.868 57.4563ZM161.061 16.6323C164.655 13.0389 164.655 7.44933 161.061 3.95583C157.568 0.362509 151.978 0.362509 148.385 3.95583C144.891 7.44933 144.891 13.0389 148.385 16.6323C151.978 20.1258 157.568 20.1258 161.061 16.6323ZM162.259 73.5265V23.6193H147.287V73.5265H162.259ZM202.461 22.2219C195.973 22.2219 191.182 24.2182 188.187 28.3105V23.6193H173.215V73.5265H188.187V46.2771C188.187 39.4897 191.781 35.9962 197.47 35.9962C202.561 35.9962 206.154 39.1903 206.154 45.0793V73.5265H221.126V42.8834C221.126 36.3955 219.33 31.4048 215.736 27.7117C212.243 24.0185 207.751 22.2219 202.461 22.2219ZM262.35 24.6227H252.068V10.6487L237.096 15.1403V24.6227H229.111V38.9959H237.096V56.6631C237.096 63.9495 238.893 68.9403 242.586 71.8349C246.279 74.6297 252.867 75.5281 262.35 74.5299V60.9551C255.063 61.3544 252.068 60.6557 252.068 56.6631V38.9959H262.35V24.6227ZM285.307 23.6193H270.335V73.5265H285.307V50.9684C285.307 46.4767 286.904 43.2827 289.998 41.486C293.192 39.5896 296.586 38.9907 300.279 39.5896V22.6211C293.492 22.6211 287.203 26.1146 285.307 32.5027V23.6193Z" />
        </svg>
      </Link>
      <input type="checkbox" id="panelProfile" />

      <div className="navProfile">
        <div>
          <Form action="/logout" method="post">
            <button className="btn btnPanel btnBefore" data-icon="logout">
              <b>Logout</b>
            </button>
          </Form>
        </div>
        <label
          htmlFor="panelProfile"
          className="btn btnPanel btnAfter profile"
          data-icon="account_circle"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 96 960 960"
            width="48"
            fill="white"
          >
            <path d="M222 801q63-44 125-67.5T480 710q71 0 133.5 23.5T739 801q44-54 62.5-109T820 576q0-145-97.5-242.5T480 236q-145 0-242.5 97.5T140 576q0 61 19 116t63 109Zm257.814-195Q422 606 382.5 566.314q-39.5-39.686-39.5-97.5t39.686-97.314q39.686-39.5 97.5-39.5t97.314 39.686q39.5 39.686 39.5 97.5T577.314 566.5q-39.686 39.5-97.5 39.5Zm.654 370Q398 976 325 944.5q-73-31.5-127.5-86t-86-127.266Q80 658.468 80 575.734T111.5 420.5q31.5-72.5 86-127t127.266-86q72.766-31.5 155.5-31.5T635.5 207.5q72.5 31.5 127 86t86 127.032q31.5 72.532 31.5 155T848.5 731q-31.5 73-86 127.5t-127.032 86q-72.532 31.5-155 31.5ZM480 916q55 0 107.5-16T691 844q-51-36-104-55t-107-19q-54 0-107 19t-104 55q51 40 103.5 56T480 916Zm0-370q34 0 55.5-21.5T557 469q0-34-21.5-55.5T480 392q-34 0-55.5 21.5T403 469q0 34 21.5 55.5T480 546Zm0-77Zm0 374Z" />
          </svg>
          <b>{name}</b>
        </label>
      </div>

      <div className="container-btnPanel">
        <Link
          className={
            isChecked("validate-license")
              ? "btn btnPanel btnBefore checked"
              : "btn btnPanel btnBefore"
          }
          data-icon="verified_user"
          to="/custom-admin/dashboard"
        >
          <b>Validate License</b>
        </Link>
        <hr />
        <Link
          className={
            isChecked("registered-cpas")
              ? "btn btnPanel btnBefore checked"
              : "btn btnPanel btnBefore"
          }
          data-icon="group"
          to="/custom-admin/dashboard?tab=registered-cpas"
        >
          <b>Registered CPAs</b>
        </Link>
        <hr />
        <Link
          className={
            isChecked("logs")
              ? "btn btnPanel btnBefore checked"
              : "btn btnPanel btnBefore"
          }
          data-icon="history"
          to="/custom-admin/dashboard?tab=logs"
        >
          <b>Admin Logs</b>
        </Link>
        <hr />
        <Link
          className={
            isChecked("affiliate-applications")
              ? "btn btnPanel btnBefore checked"
              : "btn btnPanel btnBefore"
          }
          data-icon="handshake"
          to="/custom-admin/dashboard?tab=affiliate-applications"
        >
          <b>Affiliate Applications</b>
        </Link>
        <hr />
        <Link
          className={
            isChecked("unaccepted-filings")
              ? "btn btnPanel btnBefore checked"
              : "btn btnPanel btnBefore"
          }
          data-icon="assignment_late"
          to="/custom-admin/dashboard?tab=unaccepted-filings"
        >
          <b>Unaccepted Filings</b>
        </Link>
      </div>

      <div className="navSupport">
        <h6>
          © Plaintr • All rights reserved
          <br />
          <Link to="/privacy-policy" target="_blank">
            Privacy Policy
          </Link>{" "}
          &{" "}
          <Link to="/terms-conditions" target="_blank">
            Terms
          </Link>
        </h6>
      </div>

      {/* Mobile bottom nav for admin (visible via media queries) */}
      <div className="bottomPanel">
        <Link
          className={
            isChecked("validate-license")
              ? "btn btnNavMobil btnBefore checked"
              : "btn btnNavMobil btnBefore"
          }
          data-icon="verified_user"
          to="/custom-admin/dashboard"
        >
          <b>Validate</b>
        </Link>
        <Link
          className={
            isChecked("registered-cpas")
              ? "btn btnNavMobil btnBefore checked"
              : "btn btnNavMobil btnBefore"
          }
          data-icon="group"
          to="/custom-admin/dashboard?tab=registered-cpas"
        >
          <b>CPAs</b>
        </Link>
        <Link
          className={
            isChecked("logs")
              ? "btn btnNavMobil btnBefore checked"
              : "btn btnNavMobil btnBefore"
          }
          data-icon="history"
          to="/custom-admin/dashboard?tab=logs"
        >
          <b>Logs</b>
        </Link>
        <Link
          className={
            isChecked("affiliate-applications")
              ? "btn btnNavMobil btnBefore checked"
              : "btn btnNavMobil btnBefore"
          }
          data-icon="handshake"
          to="/custom-admin/dashboard?tab=affiliate-applications"
        >
          <b>Affiliates</b>
        </Link>
        <Link
          className={
            isChecked("unaccepted-filings")
              ? "btn btnNavMobil btnBefore checked"
              : "btn btnNavMobil btnBefore"
          }
          data-icon="assignment_late"
          to="/custom-admin/dashboard?tab=unaccepted-filings"
        >
          <b>Filings</b>
        </Link>
      </div>
    </div>
  );
}

export default AdminNavBar;
